export default class BrowserService {
  static scrollToTop(y: number = 0): void {
    window.scrollTo({
      top: y,
      behavior: "instant"
    });
  }

  static scrollToId(id: string): void {
    const element = document.getElementById(id);
    element.scrollIntoView();
  }

  // url function
  static getPathname(): string {
    return window.location.pathname;
  }

  static getUrl(propertyType: string = "href"): string {
    let url;
    switch (propertyType) {
      case "href":
        url = window.location.href;
        break;
      case "pathname":
        url = window.location.pathname;
        break;
      default:
        url = "/";
    }
    return url;
  }

  static isWebview(): boolean {
    try {
      const pathname = window.location.pathname || "";
      const search = window.location.search || "";
      const params = new URLSearchParams(search);
      return (
        pathname.includes("/webview") ||
        (pathname.includes("/activity") && params.has("tokenLogin")) ||
        Boolean((window as any).ReactNativeWebView || (window as any).webkit?.messageHandlers)
      );
    } catch (error) {
      return false;
    }
  }
}
